import React from "react";
import { Divider } from "@material-ui/core";
import * as Scroll from "react-scroll";

export function OrdersPage() {
  let scroll = Scroll.animateScroll;

  React.useEffect(() => {
    scroll.scrollToTop();
  }, []);

  return (
    <>
      <div className="row">
        <div className="w-100 p-0" id="jobHd">
          <div className="container w-100 h-100 d-flex align-items-center">
            <h1 className="text-white">
              <b>راهنمای استرداد بلیط</b>
            </h1>
          </div>
        </div>
        <div className="container h-auto " style={{ marginBlock: "3rem" }}>
          <div
            className="container pt-5 bg-white landings-container"
          >
            <h2
              className="p-4 col-6 col-md-3"
              style={{ borderBottom: "2.3px solid #6dd06d" }}
            >
              <b> قوانین استرداد بلیط</b>
            </h2>
            <div className="d-block d-md-flex flex-wrap my-5">
              <div>
                <ul>
                  <li className="p-3" style={{ fontWeight: "bold" }}>
                    استرداد: هزینه کنسلی از زمان خرید بلیط تا یک ساعت قبل از
                    حرکت 10 درصد و کمتر از یک ساعت مانده به حرکت و بعد از آن 50
                    درصد قیمت بلیط می باشد.
                  </li>
                  <li className="p-3">
                    پس از اینکه در قسمت ورود یا ثبت نام در قسمت های مربوطه ایمیل
                    و رمز عبور خود را وارد کنید.
                  </li>
                  <li className="p-3">
                    در این مرحله شما قادرید با گزینه ای که پیش رو دارید یعنی
                    سفارشات و استرداد ها به صفحه ی سفارشات خود وارد شوید و لیستی
                    از سفارشات را که برای شما نمایان خواهد شد مشاهده کنید سپس می
                    توانید هر یک از آن ها را که مد نظر دارید برای استرداد انتخاب
                    کنید.
                  </li>
                  <li className="p-3">
                    در قسمت بالای صفحه سفارشات و استرداد ها قسمتی وجود دارد که
                    کافی است فیلد هایی که مرتبط با شماره سفارش و تاریخ هستند را
                    پر کنید به این ترتیب به راحتی می توانید مورد مدنظر خود را
                    پیدا کرده و مشاهده کنید.
                  </li>
                  <li className="p-3">
                    پس از اینکه سفارش مد نظر خود را انتخاب کردید این امکان برای
                    شما فراهم می شود که جزئیات سفارش خود را به صورت کامل بررسی
                    کرده و سپس آن را چاپ کنید. علاوه بر آن از گزینه ی استرداد هم
                    می توانید برای استرداد هر یک از بلیط هایی که سفارش داده
                    بودید استفاده کنید.
                  </li>
                  <li className="p-3">
                    در صورتی که گزینه ی استرداد را انتخاب کنید صفحه ای برای شما
                    نمایان خواهد شد که می توانید تمامی اطلاعات مرتبط با مبلغ
                    قابل استرداد طبق شرایط و قوانین لغو بلیط اتوبوس خود مشاهده
                    کنید و پس از آن به تایید آن بپردازید.
                  </li>
                </ul>
              </div>
              <div className="p-5">
                <p className="p-4" style={{ fontWeight: "bold" }}>
                  در صورت بروز مشکل و سوال با شماره زیر تماس بگیرید :
                  33450171-024
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
